import monsters_abyss from './cards/monsters/abyss.json'
import monsters_cave from './cards/monsters/cave.json'
import monsters_desert from './cards/monsters/desert.json'
import monsters_forest from './cards/monsters/forest.json'
import monsters_enchanted_lands from './cards/monsters/enchanted_lands.json'
import monsters_underworld from './cards/monsters/underworld.json'

import heal from './cards/heal.json'
import gold from './cards/gold.json'
import shield from './cards/shield.json'
import item from './cards/item.json'
import biome from './cards/biome.json'
import drop from './cards/drop.json'
import place from './cards/place.json'

var monster = {
	abyss: monsters_abyss,
	cave: monsters_cave,
	desert: monsters_desert,
	forest: monsters_forest,
	enchanted_lands: monsters_enchanted_lands,
	underworld: monsters_underworld
}

const cards = {
	monster,
	heal,
	gold,
	shield,
	item,
	biome,
	place,
	drop,
}

export default cards